import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background: var(--background-primary);
  color: var(--text-primary);
  padding: 0;
  margin: 0;
`;

const Header = styled.header`
  background: var(--background-secondary);
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-primary);
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(8px);
  box-shadow: var(--shadow-sm);
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  background: linear-gradient(135deg, var(--accent-primary) 0%, var(--primary-700) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const Content = styled.main`
  padding: 24px;
  max-width: 100%;
  overflow-x: auto;
  
  @media (max-width: 768px) {
    padding: 16px;
  }
`;


interface LayoutProps {
  children: React.ReactNode;
  title?: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, title = 'Caller Agent Admin' }) => {
  return (
    <Container>
      <Header>
        <HeaderContent>
          <Title>{title}</Title>
        </HeaderContent>
      </Header>
      <Content>
        {children}
      </Content>
    </Container>
  );
};